import React from 'react';
import { WithPermissions, MenuItemLink } from "react-admin";

import users from "../../users";
import transactions from "../../transactions";
import fundings from "../../fundings";
import accounts from "../../accounts";
import statements from "../../statements";
import SubMenu from "../SubMenu";
import reports from "../../reports";

import FileIcon from "@material-ui/icons/InsertDriveFile";
import BusinessIcon from "@material-ui/icons/Business";
import ambassador from "../../ambassador";
import discount_codes from "../../discount-code";

// Operator menu
export const OperatorSideMenu = ({ handleToggle, menuBusiness, menuDocs, menuCatalog, open, translate, onMenuClick }) => (
    <WithPermissions
        render={({ permissions }) => (
            permissions === 'operator'
                ? <>
                    <MenuItemLink
                        to={`/accounts`}
                        primaryText={translate(`resources.accounts.name`, {
                            smart_count: 2
                        })}
                        leftIcon={<accounts.icon />}
                        onClick={onMenuClick}
                    />
                    <MenuItemLink
                        to={`/fundings`}
                        primaryText={translate(`resources.fundings.name`, {
                            smart_count: 2
                        })}
                        leftIcon={<fundings.icon />}
                        onClick={onMenuClick}
                    />
                    <SubMenu
                        handleToggle={() => handleToggle("menuBusiness")}
                        isOpen={menuBusiness}
                        sidebarIsOpen={open}
                        name="pos.menu.ambassador"
                        icon={<ambassador.icon />}
                    >
                        <MenuItemLink
                            to={`/user/ambassador/posts`}
                            primaryText={translate(`resources.posts.name`)}
                                leftIcon={<ambassador.postIcon />}
                                onClick={onMenuClick}
                        />
                        <MenuItemLink
                            to={`/user/ambassador/commissions`}
                            primaryText={translate(`resources.commissions.name`)}
                            leftIcon={<ambassador.commissionIcon />}
                            onClick={onMenuClick}
                        />
                    </SubMenu>
                    <MenuItemLink
                        to={`/discount/codes`}
                        primaryText={translate(`resources.discount_codes.name`)}
                        leftIcon={<discount_codes.icon />}
                        onClick={onMenuClick}
                    />
                    <MenuItemLink
                        to={`/transactions`}
                        primaryText={translate(`resources.transactions.name`, {
                            smart_count: 2
                        })}
                        leftIcon={<transactions.icon/>}
                        onClick={onMenuClick}
                    />
                    {/*
                    <SubMenu
                        handleToggle={() => handleToggle("menuDocs")}
                        isOpen={menuDocs}
                        sidebarIsOpen={open}
                        name="pos.menu.docs"
                        icon={<FileIcon />}
                    >
                        <MenuItemLink
                            to={`/reports`}
                            primaryText={translate(`resources.reports.name`, {
                                smart_count: 2
                            })}
                            leftIcon={<reports.icon />}
                            onClick={onMenuClick}
                        />
                        <MenuItemLink
                            to={`/statements`}
                            primaryText={translate(`resources.statements.name`, {
                                smart_count: 2
                            })}
                            leftIcon={<statements.icon />}
                            onClick={onMenuClick}
                        />
                    </SubMenu>
                    */}
                </>
                : null
        )}
    >
    </WithPermissions>
)